<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Name</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                :value="client.contact_edit.FirstName"
                @change="v => client.contact_edit.FirstName = v"
                placeholder="FirstName"
                required
                type="text"
                id="FirstName"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Name</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.LastName"
                placeholder="LastName"
                required
                type="text"
                id="LastName"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Title</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.Title"
                placeholder="Title"
                required
                type="text"
                id="Title"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Phone</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.Phone1"
                placeholder="Office Phone"
                required
                type="text"
                id="Phone1"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Mobile</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.Phone2"
                placeholder="Mobile/Cell"
                required
                type="text"
                id="FirstName"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Email (primary)</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.Email1"
                placeholder="Primary Email Address"
                required
                email
                type="text"
                id="Email1"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Email (secondary)</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.contact_edit.Email2"
                placeholder="Alternate Email Address"
                required
                email
                type="text"
                id="Email2"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
              <b-button
                style="display:none;"
                class="mr-0 mt-2 invisible"
                size="md"
                variant="primary"
                type="submit"
              ></b-button>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
//import Datepicker from "vuejs-datepicker";
//import "bootstrap/dist/css/bootstrap.css";

// Import this component
import datepicker from "vue-bootstrap-datetimepicker";
//import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "LocationCard",
  computed: {
    ...mapState(["client"]),
    ...mapActions("saveOp", {
      prefix_DestroySaveOperation: "DestroySaveOperation",
      prefix_BuildSaveOperation: "BuildSaveOperation",
      prefix_EmitSave: "EmitSave"
    }),
    ...mapActions("client", {
      prefix_AddContact: "AddContact"
    })
  },
  components: {
    datepicker
  },
  data: () => {
    return {
      location: {},
      dirtyFields: [],
      saveUrl: "/Client/SaveContact"
    };
  },
  methods: {
    save() {
      this.prefix_BuildSaveOperation.then(
        this.prefix_EmitSave.then(this.$store.state.saveOp.DestroySaveOperation)
      );
      this.prefix_AddContact;
      this.$bvModal.hide("modal-3");
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        if (
          this.dirtyFields.filter(
            dirtyField => dirtyField.FieldName !== event.target.id
          ).length === 0
        ) {
          this.dirtyFields.push({
            FieldName: event.target.id,
            FieldValue: event.target.value
          });
          this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        }
      }
    }
    // this.$store.state.saveOp.localDirtyFields = this.$store.state.saveOp.localDirtyFields.filter(
    //   dirtyField => dirtyField.FieldName !== event.target.id
    // );
    // this.$store.state.saveOp.localDirtyFields.push({
    //   FieldName: event.target.id,
    //   FieldValue: event.target.value
    // });
  },
  created() {},
  mounted() {
    this.$store.state.saveOp.localUrl = "/Client/SaveContact/";
    this.$store.state.saveOp.localVariableName = "_cc";
    this.$store.state.saveOp.localVariableObject = this.$store.state.client.contact_edit;
    this.$store.state.saveOp.localFieldToSet = "ContactID";
    this.$store.state.saveOp.localReturnObject = "SaveContactResult";
  }
};
</script>

<style  scoped>
</style>